import {i18n} from '~/i18n';
import {DEFAULT_BG_COLOR} from '~/utils/theme.constants';

export const colorPalette = [
  [DEFAULT_BG_COLOR],
  ['#FF3B30'],
  ['#FFCC00'],
  ['#34C759'],
  ['#FF2D55'],
  ['#5856D6'],
  ['#FBB54C'],
  ['#010236'],
  ['#B21A5E'],
  ['#E2E6EF'],
  ['#203E51'],
  ['#50A3EF'],
  ['#1c1c1c'],
  ['#FFF'],
  ['#50A3EF', DEFAULT_BG_COLOR],
  ['#FF2D55', '#FF3B30'],
  ['#203E51', '#1c1c1c'],
  ['#216A2E', '#309D44'],
  ['#A52754', '#D6346C'],
  ['#FAB432', '#FFCB29'],
  ['#1864AB', '#1B7ED5'],
];

export const paletteOptions = [
  {
    text: i18n('toolbar.fill'),
    value: 'solid',
  },
  {
    text: i18n('toolbar.gradient'),
    value: 'gradient',
  },
  {
    text: i18n('toolbar.custom'),
    value: 'custom',
  },
];

export const paletteOptionsSolid = [
  paletteOptions[0],
  paletteOptions[2],
];